/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import { Navbar, Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
// import logo from "../assets/img/logo.svg";
// import logo2 from "../assets/img/logo2.png";
// import logo4 from "../assets/img/logo4.png";
// import logo3 from "../assets/img/logo3.png";
import logo5 from "../assets/img/logo5.png";
import navIcon1 from "../assets/img/nav-icon1.svg";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  //To set the scroll behavious of the navigation bar
  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.addEventListener("scroll", onScroll);
  }, []);
  //To set the behaviour the link when it is active
  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };
  return (
    <Navbar expand="lg" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand href="#home">
          <img src={logo5} alt="logo"></img>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              href="#home"
              className={
                activeLink === "home" ? "active navbar-link" : "navbar-link"
              }
              onClick={() => onUpdateActiveLink("home")}
            >
              Home
            </Nav.Link>
            <Nav.Link
              href="#services"
              className={
                activeLink === "services" ? "active navbar-link" : "navbar-link"
              }
              onClick={() => onUpdateActiveLink("services")}
            >
              Services
            </Nav.Link>
            <Nav.Link
              href="#pricing"
              className={
                activeLink === "pricing" ? "active navbar-link" : "navbar-link"
              }
              onClick={() => onUpdateActiveLink("pricing")}
            >
              Pricing
            </Nav.Link>
          </Nav>
          <span className="navbar-text">
            <div className="social-icon">
              <a href="https://www.linkedin.com/company/altruistedigital/">
                <img src={navIcon1} alt="icon"></img>
              </a>
              <a href="#">
                <img src={navIcon2} alt="icon"></img>
              </a>
              <a href="https://www.instagram.com/altruiste">
                <img src={navIcon3} alt="icon"></img>
              </a>
            </div>
            <button className="vvd" onClick={() => console.log("connected")}>
              <span>Let's Connect</span>
            </button>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
